import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles(theme => ({
  field: {
    marginBottom: 30,
  },
  formControl: {
    minWith: 120,
    marginBottom: 20
  },
  disabledSelect: {
    color: theme.palette.text.primary,
  },
}))

export default useStyles
